import { DotChartOutlined, TableOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { SingleGraphReferenceContextProvider } from 'business/providers/graph-reference';
import { ActivityTreeMetadata } from 'business/shift-report/report-analyze/pages/activity-analyze/components/aside-activity-tree/use-activity-tree';
import ReportActivityAnalyzeGraphContainer from 'business/shift-report/report-analyze/pages/activity-analyze/components/display-container';
import { MobileActivityAnalyzeFilters } from 'business/shift-report/report-analyze/pages/activity-analyze/mobile/components/filters';
import { ReportActivityAnalyzeFiltersProvider } from 'business/shift-report/report-analyze/pages/activity-analyze/providers/filters';
import Routes from 'config/routes';

export const MobileActivityAnalyze = ({
  constructionSiteId,
  activityTreeMetadata,
}: {
  constructionSiteId: string;
  activityTreeMetadata: ActivityTreeMetadata;
}) => {
  const { t } = useTranslation();

  const [showTable, setShowTable] = useState(false);

  return (
    <SingleGraphReferenceContextProvider>
      <ReportActivityAnalyzeFiltersProvider
        constructionSiteId={constructionSiteId}
        allActivitiesChecked={activityTreeMetadata.allActivitiesChecked}
      >
        <MobileSingleCardPageWithFilterLayout
          title={t('pages.manager.taskAnalyzer.title')}
          mainPageRedirection={Routes.ReportDashboardAnalyze}
          filters={<MobileActivityAnalyzeFilters />}
          corner={
            <Switch
              value={showTable}
              onChange={(value) => setShowTable(value)}
              checkedChildren={<TableOutlined />}
              unCheckedChildren={<DotChartOutlined />}
            />
          }
        >
          <ReportActivityAnalyzeGraphContainer
            showTable={showTable}
            activityTreeMetadata={activityTreeMetadata}
          />
        </MobileSingleCardPageWithFilterLayout>
      </ReportActivityAnalyzeFiltersProvider>
    </SingleGraphReferenceContextProvider>
  );
};
